import "angular";
import "angular-ui-router";
import BranchesViewController from "./BranchesViewController";
import BranchesViewRouteStates from "./BranchesViewRouteStates";

var BranchesModule = angular.module("BranchesModule", [
    // Libraries
    "ngResource",
    "ui.router"
]);
// Controllers
BranchesModule.controller("BranchesViewController", BranchesViewController);
BranchesModule.config(BranchesViewRouteStates);

export default BranchesModule;
